<div class="shape color-shape" [class.classic]="isClassicStyle()">
  @if (isClassicStyle()) {
    <svg class="shape-svg" viewBox="0 0 50 50" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      <polygon points="12.5,0 37.5,0 50,25 0,25" [attr.fill]="topFill()" />
      <polygon points="0,25 50,25 37.5,50 12.5,50" [attr.fill]="bottomFill()" />
      <polygon
        points="12.5,0 37.5,0 50,25 37.5,50 12.5,50 0,25"
        fill="none"
        [attr.stroke]="borderColor()"
        stroke-width="1"
        stroke-linejoin="round"
        vector-effect="non-scaling-stroke"
      />
    </svg>
  } @else {
    <svg class="shape-svg" viewBox="0 0 50 50" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      <path d="M 0 25 A 25 25 0 0 1 50 25 Z" [attr.fill]="topFill()" />
      <path d="M 0 25 A 25 25 0 0 0 50 25 Z" [attr.fill]="bottomFill()" />
    </svg>
  }
  <span class="shape-number" [style.color]="numberColor()" [style.text-shadow]="numberTextShadow()">{{ colorNumber() }}</span>
</div>
